import SideNavLayout from "../../customsidenav/sidenavlayout"

const Procedures=()=>{
    return(<>
    <SideNavLayout>

 procedures

    </SideNavLayout>
   
    </>)
}
export default Procedures